// Discrepancy-popup sections for a Link contracts row; both row types carry their own items.

// A contract row — mirrors the Linked Contracts tab's own popup.
export const buildContractRowDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        {
          label: t('FIELD_CONTRACT_ID'),
          value: row.contractId,
        },
        { label: t('FIELD_TOTAL_SHIPMENT_LINKED'), value: row.totalShipmentLinked },
        {
          label: t('FIELD_DELIVER_BY'),
          value: row.deliverBy,
        },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_ASSIGNED_QUANTITY_CONTRACT'), value: unit.assignedQuantity },
        {
          label: t('FIELD_CONTRACTED_QUANTITY'),
          value: unit.contractedQuantity,
        },
        {
          label: t('FIELD_OUTSTANDING_QUANTITY'),
          value: unit.outstandingQuantity,
        },
      ],
    },
  ];
};

// A shipment row — the same sections the shipments list's popup shows.
export const buildShipmentRowDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: row.materialName },
        { label: t('FIELD_SENT_BY'), value: row.supplierName },
        { label: t('FIELD_RECEIVED_AT'), value: row.facilityName },
        { label: t('FIELD_TERMINAL'), value: row.terminal },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: unit.shipmentQuantity },
        {
          label: t('FIELD_RECEIVED_DECLARATION_QUANTITY'),
          value: unit.receivedDeclarationQuantity,
        },
        { label: t('FIELD_UNASSIGNED_QUANTITY'), value: unit.unassignedQuantity },
      ],
    },
  ];
};
